module.exports = __webpack_public_path__ + "img/9788954613316.f165cfd1.jpg";